import baseConfig from './baseConfig'
import {clientCsaveExtensionsWithoutBrowserRendererModel} from './csaveConfigs'

export default {
    runStylesGC: false,
    supportMobile: true,
    postUpdateOperation: false,
    disableAutoSave: true,
    transactionActionsLimit: 500,
    csaveSnapshotActionsLimit: 500,
    csaveTransactionsLimit: 100,
    minNumOfPagesToCalculateRenderHints: 0,
    supportedFragments: {
        FragmentIndex: {
            loadOnInit: true
        },
        AppState: {
            loadOnInit: true
        }
    },
    modulesList: [
        'atomicScopesPublicAPI',
        'accountPublicAPI',
        'accessibilityPublicAPI',
        'branchesPublicAPI',
        'structurePublicAPI',
        'dataModelPublicAPI',
        'featuresPublicAPI',
        'slotsPublicAPI',
        'refComponentPublicAPI',
        'statesPublicAPI',
        'triggersPublicAPI',
        'reactionsPublicAPI',
        'documentModePublicAPI',
        'feedbackPublicAPI',
        'remoteStructureMetaDataPublicApi',
        'renderPluginsPublicApi',
        'savePublicAPI',
        'componentPublicAPI',
        'innerElementsPublicAPI',
        'componentStylePublicAPI',
        'smartBoxesPublicAPI',
        'componentDetectorPublicAPI',
        'siteMetadataPublicAPI',
        'themePublicAPI',
        'globalStylesPublicAPI',
        'pagePublicAPI',
        'pagesGroupPublicAPI',
        'siteSegmentsPublicAPI',
        'componentsMetaDataPublicAPI',
        'appControllerDataPublicAPI',
        'connectionsPublicAPI',
        'platformPublicAPI',
        'tpaPublicAPI',
        'routersPublicAPI',
        'autosavePublicAPI',
        'biPublicAPI',
        'variantsPublicAPI',
        'environmentPublicAPI',
        'actionsAndBehaviorsPublicAPI',
        'debugPublicAPI',
        'fontsPublicAPI',
        'browserThemeColorPublicAPI',
        'mobilePublicAPI',
        'menuPublicAPI',
        'errorsPublicAPI',
        'inlinePopupPublicAPI',
        'multilingualPublicAPI',
        'partnersPublicAPI',
        'variablesPublicAPI',
        'scopesPublicAPI',
        'patternsPublicAPI',
        'keyframeEffectPublicAPI',
        'effectsPublicAPI',
        'deprecatedOldBadPerformancePublicAPI',
        'classicResponsiveLayoutPublicAPI',
        'customCSSPublicAPI',
        'externalComponentsPublicAPI',
        'historyAPI',
        'observablesPublicAPI'
    ],
    extensionsList: [
        ...baseConfig.extensionsList,
        'undoRedo',
        'metadata',
        'save',
        'lifecycle',
        'layoutCircuitBreaker',
        'viewerRuntime',
        'contactFormMetaData',
        'appBuilder',
        'documentToViewer',
        'wixapps',
        'accountInfo',
        'commonConfig',
        'seo',
        ...clientCsaveExtensionsWithoutBrowserRendererModel,
        'componentsByType',
        'partners',
        'views',
        'platformWithViewer',
        'componentsRegistry'
    ]
}
